module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3NjgiIGhlaWdodD0iNzY4IiB2aWV3Qm94PSIwIDAgNzY4IDc2OCI+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTI3NC41IDUyMy41bDE0Ny0xNDctMTQ3LTE0NyA0NS00NSAxOTIgMTkyLTE5MiAxOTJ6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ../components/carousel/img/right-arrow.svg
// module id = 469
// module chunks = 0